import React from 'react';
import useIsMobile from 'components/Dashboard/utilities/useIsMobile';
import useValidateContactsOversubscribed from 'components/Dashboard/utilities/useValidateContactsOversubscribed';
import { Link } from 'react-router-dom';

function CreateEmailLink({ showToolTip, text, redirectToEmails, noIcon, additionalText }) {
  const isSmallMobile = useIsMobile(520);
  const { contactsOversubscribed } = useValidateContactsOversubscribed();
  return (
    <Link
      className={
        isSmallMobile && !noIcon
          ? 'add-to-contact-mobile-button'
          : `general-button sort-button d-lg-block top-nav-create-email-button ${showToolTip ? 'top-nav-create-email-button-disabled' : ''}`
      }
      data-tooltip-content={showToolTip && !isSmallMobile ? 'Please configure an email domain' : undefined}
      data-tooltip-id={showToolTip && !isSmallMobile ? 'general-tooltip' : undefined}
      data-tooltip-class-name={showToolTip && !isSmallMobile ? 'header-tooltip pricing-tooltip-description' : undefined}
      to={
        (showToolTip && !isSmallMobile) || contactsOversubscribed < 0
          ? '#'
          : redirectToEmails
            ? `/people/emails`
            : `/people/emails/create`
      }
    >
      {isSmallMobile && !noIcon ? '' : text ? text : 'Create email'}
      {additionalText && <span className='d-none d-lg-inline-block'>{additionalText}</span>}
    </Link>
  );
}

export default CreateEmailLink;
